import {
	ResponsiveContainer,
	ComposedChart,
	XAxis,
	YAxis,
	Bar,
	Line,
	LabelList,
	Tooltip,
	BarChart,
	Legend,
	Scatter,
	ReferenceLine
} from "recharts";
import { numberFormatter } from "../../utils";
import moment from "moment";
import { useState } from "react";
import divider from "../../assets/divider-logo.3699f955.svg";
interface Props {
	chartData: Array<T>;
	heading: any;
	page: any;
}

interface T {
	quarter: string;
	actual: number;
	forecastedSpend: number;
	spendNeededForNextTier: number;
	spendShift: number;
	targetGrowthSpend: number;
}

const MarginValueCapture = (props: Props) => {
	let chartData: any = props?.chartData;
	const { page } = props;
	let breakEvenPoint = "";
	let monthCount = 0;
	const CustomLabel2 = (props: any) => {
		const { x, y, value, index } = props;
		const offset = 30; // Distance from the data point
		return (
			<g>
				{index == chartData?.graph2?.length - 1 ? (
					<>
						<text
							x={x - offset}
							y={
								y +
								(chartData?.calculationData?.actualized < 0
									? -30
									: offset)
							}
							fill="#071158"
							fontWeight={500}
							fontSize={`${page == "summary" ? "2vh" : "1.8vh"}`}
						>
							{numberFormatter(value, 2, "$")}
						</text>
						<text
							x={x - offset - 60}
							y={
								y +
								(chartData?.calculationData?.actualized < 0
									? -10
									: offset + 15)
							}
							fill="black"
							fontWeight={400}
							fontSize={`${page == "summary" ? "2vh" : "1.8vh"}`}
						>
							Projected by Year-End
						</text>
					</>
				) : (
					""
				)}
			</g>
		);
	};
	let chartDataCopy: any;
	if (chartData?.graph2?.length > 0) {
		chartDataCopy = JSON.parse(JSON.stringify(chartData?.graph2));
		chartDataCopy?.map((item: any, k: any) => {
			breakEvenPoint = !chartData?.calculationData?.breakEvenPoint
				? ""
				: `${moment(
						new Date(chartData?.calculationData?.breakEvenPoint)
				  ).format(`MMM'YY`)}`;
			if (
				item?.monthStartDate ===
				chartData?.calculationData?.breakEvenPoint
			) {
				item.vendor = `Devaluation Breakeven by: ${moment(
					new Date(chartData?.calculationData?.breakEvenPoint)
				).format("MMM,YY")}`;
				item.dotValue =
					item?.projectedSalesCumilative +
					item?.incrementalNIAEstimate;
			} else {
				item.vendor = null;
				item.dotValue = null;
			}
			let a: any = item.monthStartDate;
			a = a?.split("-");
			a[2] = "02";
			item.monthStartDate = a.join()?.replaceAll(",", "-");
			item.date = moment(new Date(item.monthStartDate)).format("MMM");
			if (item.monthlyRev != 0) {
				item.totalrev =
					item?.projectedSalesCumilative +
					item?.incrementalNIAEstimate;
				monthCount = monthCount + 1;
			}

			if (k == 0) {
				item.refline =
					item?.projectedSalesCumilative +
					chartData?.graph2[k].incrementalNIAEstimate;
				item.rev = item?.projectedSalesCumilative;
			} else if (k == chartDataCopy?.length - 1) {
				item.refline =
					item?.projectedSalesCumilative +
					chartData?.graph2[k].incrementalNIAEstimate;
				item.rev =
					item.monthlyRev == 0 ? 0 : item?.projectedSalesCumilative;
				if (item.monthlyRev == 0) {
					item.incrementalNIAEstimate = 0;
				}
			} else {
				item.refline = null;
				item.rev =
					item.monthlyRev == 0 ? 0 : item?.projectedSalesCumilative;
				if (item.monthlyRev == 0) {
					item.incrementalNIAEstimate = 0;
				}
			}
		});
	}

	let heading = props?.heading;

	const customTooltip = ({ active, payload }: any) => {
		if (active && payload && payload.length) {
			const data = payload[0].payload;

			const popupStyle = {
				width: "fit-content",
				background: "white",
				border: "1px solid #ccc",
				boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
				borderRadius: "1vh",
				color: "black",
				padding: 0,
			};

			return (
				<>
					{data.monthlyRev !== 0 && (
						<div style={popupStyle}>
							{/* Header Row */}
							<div className="w-full flex justify-start h-[3vh] items-center bg-[#f0f4f8] py-[3vh] px-[1vh] textSmall">
								<div className="font-bold uppercase">
									Month:
								</div>
								<div
									className="font-bold ml-1"
									style={{ color: "#3f3f3f" }}
								>
									{data.date}
								</div>
							</div>

							{/* Data Rows */}
							<div className="h-fit p-[1vh] mt-[.5vh] mb-[.5vh]">
								<p
									className="label"
									style={{ padding: 0, margin: 0 }}
								>
									<label
										className="graph-label-small"
										style={{
											color: "#5a5a5a",
											fontWeight: "normal",
										}}
									>
										Actualized Margin Benefit :{" "}
									</label>
									<label
										className="graph-label-small"
										style={{
											color: "#3f3f3f",
											fontWeight: "bold",
										}}
									>
										{numberFormatter(
											data.monthlyRev,
											2,
											"$"
										)}
									</label>
								</p>
								<p
									className="label"
									style={{ padding: 0, margin: 0 }}
								>
									<label
										className="graph-label-small"
										style={{
											color: "#5a5a5a",
											fontWeight: "normal",
										}}
									>
										Incremental NIA Benefit :{" "}
									</label>
									<label
										className="graph-label-small"
										style={{
											color: "#3f3f3f",
											fontWeight: "bold",
										}}
									>
										{numberFormatter(
											data.incrementalNIAEstimateMonthly,
											2,
											"$"
										)}
									</label>
								</p>
							</div>
						</div>
					)}
				</>
			);
		}
		return null;
	};

	const CustomLegend = () => (
		<div
			style={{
				display: "flex",
				gap: "2rem",
				alignItems: "center",
				color: "black",
				fontSize: "0.8rem",
			}}
		>
			<span>
				<span
					style={{
						display: "inline-block",
						width: 10,
						height: 18,
						background: "#012169",
						marginRight: 8,
						verticalAlign: "middle",
					}}
				/>
				Actualized Margin Benefit
			</span>
			<span>
				<span
					style={{
						display: "inline-block",
						width: 10,
						height: 18,
						background: "#62b5e5",
						marginRight: 8,
						verticalAlign: "middle",
					}}
				/>
				Incremenatal NIA Benefits
			</span>
		</div>
	);
	const renderCustomLegend = (props: any) => {
		const { payload } = props;
		console.log(payload);
		return (
			<ul className="graphLegend" style={{ width: "29vw" }}>
				{payload.map((entry: any, index: any) => (
					<li
						key={`item-${index}`}
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "flex-end",
							marginBottom: 4,
							color: "black",
							fontSize: `${
								page == "summary" ? "1.8vh" : "1.4vh"
							}`,
						}}
					>
						{entry.value !== "refline" &&
							entry?.value !== "dotValue" && (
								<>
									{entry.value !== "rev" ? (
										<img
											src={divider}
											alt="divder"
											style={{
												marginLeft: "0.5vw",
												marginRight: "0.5vw",
											}}
										/>
									) : (
										<></>
									)}
									<div
										style={{
											width: "0.5vh",
											height: "2vh",
											display: "inline-block",
											marginRight: 5,
											position: "relative",
											backgroundColor: entry.color,
										}}
									></div>
									{entry.value === "rev"
										? "Actualized Margin Benefit"
										: "Incremental NIA Benefit"}
								</>
							)}
						{/* {  entry?.value==="dotValue"&&breakEvenPoint!==''&& <>
            <span className="font-bold">

            { 'Devaluation Breakeven by: '} <span className="text-blue-600">{breakEvenPoint}</span>
            </span>
            </> } */}
					</li>
				))}
			</ul>
		);
	};
	console.log(chartDataCopy,'test')
	return (
		<div className={`w-full graphBox h-[100%]`}>
			{/* <div
				className={`bg-[#ffff] graphBorder flex ${
					page == "summary" ? "" : "flex-col"
				} justify-between`}
			>
				<p className="text-center graphTitle pl-[1vh]">
					{" "}
					<span>{`${page == "summary" ? "6. " : "4. "}`}</span>
					{heading}{" "}
				</p>
				<p className="px-[2vh] flex justify-end font-semibold text-[1.8vh] text-[#40a108] mt-[0]">
					{numberFormatter(
						chartData?.calculationData?.actualized,
						2,
						"$"
					)}{" "}
					Actualized to-date
				</p>
			</div> */}
			<div className="headSpace">
				<span className="headContent !text-[1vw]"> {heading}</span>
				<p className="flex justify-end px-[2vh] font-semibold textNormal mt-[0] text-[#40a108]">
					{numberFormatter(
						chartData?.calculationData?.actualized,
						2,
						"$"
					)}{" "}
					Actualized to-date
				</p>
			</div>

			<div className="h-full">
				<div className="h-[0] flex w-full justify-start">
					
						<div className="flex flex-col">
							{breakEvenPoint !== "" && (
							<span className="font-bold px-[1vh] pt-[.5vh] text-black">
								{"Devaluation Breakeven by: "}{" "}
								<span className="text-blue-600">
									{breakEvenPoint}
								</span>
							</span>)}
							
							<span className="font-bold px-[1vh] pt-[.5vh] text-black">
								<span className="text-blue-600">
									{numberFormatter(chartDataCopy[chartDataCopy?.length-1].refline, 2, "$")}
								</span>
								{" "}{"Projected by Year-End"}
							</span>
						</div>
					
				</div>
				<ResponsiveContainer
					width="100%"
					height="65%"
					className={`bg-[#ffff]`}
				>
					<ComposedChart
						stackOffset="sign"
						data={chartDataCopy}
						layout="horizontal"
						className="pt-[4vh]"
					>
						<XAxis
							className="graph-label-small "
							stroke="black"
							type="category"
							orientation={"bottom"}
							dataKey="date"
							interval={0}
						/>
						<YAxis hide domain={["auto", "auto"]} type="number" />
						<ReferenceLine y={0} stroke="#000" />
						{["rev", "incrementalNIAEstimate"].map(
							(barItem: any, ind: number) => {
								return (
									<Bar
										key={barItem}
										dataKey={barItem}
										stackId="a"
										fill={ind == 0 ? "#012169" : "#62b5e5"}
										barSize={40}
									>
										{barItem ==
											"incrementalNIAEstimate" && (
											<LabelList
												dataKey="totalrev"
												content={($) => (
													<CustomLabel
														payload={$}
														page={page}
														monthCount={monthCount}
													/>
												)}
											/>
										)}
									</Bar>
								);
							}
						)}

						<Tooltip
							contentStyle={{
								color: "white",
								backgroundColor: "rgb(26, 25, 22)",
							}}
							cursor={{ strokeDasharray: "3 3", fill: "#212121" }}
							content={customTooltip}
						/>

						<Line
							type="monotone"
							dataKey="refline"
							legendType="none"
							stroke="gray"
							strokeDasharray="10 5"
							connectNulls={true}
							strokeWidth={1}
							dot={false}
						>
							{/* <LabelList
								dataKey="refline"
								content={CustomLabel2}
							/> */}
						</Line>
						<Scatter
							dataKey="dotValue"
							fill="none"
							legendType="none"
						>
							<LabelList
								dataKey="vendor"
								fill="black"
								fontWeight={700}
								fontSize="1.8vh"
								formatter={(value: number) => ``}
								position="top"
							/>
						</Scatter>
					</ComposedChart>
				</ResponsiveContainer>
				<div className="contentFooter !justify-end">
					<CustomLegend></CustomLegend>
				</div>
			</div>
		</div>
	);
};

const CustomLabel = (props: any) => {
	const payload = props.payload;
	const { page, monthCount } = props;
	return (
		<g>
			{payload?.value > 0 &&
				(page == "summary"
					? payload.index == monthCount - 1
					: !(payload.index % 2)) && (
					<text
						x={page == "summary" ? payload.x + 2 : payload.x - 8}
						y={payload.y - 5}
						fill="black"
						fontWeight={700}
						fontSize={`${page == "summary" ? "1.8vh" : "1.8vh"}`}
					>
						{numberFormatter(payload.value, 2, "$")}
					</text>
				)}
		</g>
	);
};

export default MarginValueCapture;
